import React from "react";
import { createRoot } from "react-dom/client";
import CookieConsent from "react-cookie-consent";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { BandwidthProvider } from "./context/BandwidthContext";
import reportWebVitals from "./reportWebVitals";
import "./styles/theme.css";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BandwidthProvider>
      <App />
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        cookieName="AkinolaOshinubiCookieConsent"
        expires={150}
        enableDeclineButton
        flipButtons
        disableStyles
        containerClasses="cookie-banner"
        contentClasses="cookie-banner__text"
        buttonWrapperClasses="cookie-banner__actions"
        buttonClasses="btn btn-primary"
        declineButtonClasses="btn btn-ghost"
      >
        <span className="cookie-banner__icon" aria-hidden="true">🍪</span>
        This website uses cookies to personalize your experience, remember your
        preferences, and improve overall functionality.
      </CookieConsent>
      </BandwidthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
